import { Stack, Typography } from "@mui/material";
import React from "react";
import { DocumentSvg } from "@onair/ui/svg/document";

interface Props {
	showIcon?: boolean;
}

const DocHeader = ({ showIcon = true }: Props) => {
	return (
		<Stack direction="row" spacing={2} alignItems="center">
			{showIcon && <DocumentSvg />}
			<Stack direction="row" spacing={1} alignItems="center">
				<Typography variant="subtitle1" flex={1}>
					Tài liệu
				</Typography>
			</Stack>
		</Stack>
	);
};

export default DocHeader;
